var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-left_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30.27 20.872 19.142 32 30.27 43.128l11.128 11.128 2.132-2.132 2.132-2.132-8.996-8.996L27.67 32l8.996-8.996 8.996-8.996-2.132-2.132-2.132-2.132z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMwLjI3IDIwLjg3MjFMMTkuMTQyMSAzMi4wMDAxTDMwLjI3IDQzLjEyODFMNDEuMzk3OSA1NC4yNTZMNDMuNTI5OSA1Mi4xMjRMNDUuNjYxOCA0OS45OTIxTDM2LjY2NiA0MC45OTYxTDI3LjY3MDEgMzIuMDAwMUwzNi42NjYgMjMuMDA0MUw0NS42NjE4IDE0LjAwODFMNDMuNTI5OSAxMS44NzYxTDQxLjM5NzkgOS43NDQxNEwzMC4yNyAyMC44NzIxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";